import { render, staticRenderFns } from "./le-jumpto-detail.vue?vue&type=template&id=20edd6e8&"
import script from "./le-jumpto-detail.vue?vue&type=script&lang=js&"
export * from "./le-jumpto-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports